<blockable-div id="contact-details-container" #details>
  <app-progress-spinner [enabled]="!contact" />
  <p-blockUI
    [blocked]="saving === true || loading === true"
    [target]="details"
  />
  @if (contact) {
    <div id="contact-details">
      <div id="contact-action-buttons">
        <div
          [className]="
            isUnavailable === true
              ? 'unavailable xtra-small-top-padding'
              : 'xtra-small-top-padding'
          "
        >
          <h2>
            {{ contact.firstName }} {{ contact.lastName }}
            @if (isUnavailable) {
              <span>{{ 'CONTACT.LABEL.UNAVAILABLE' | translate }}</span>
            }
          </h2>
        </div>
        <div class="no-padding">
          @if (canEdit || (canEditOwn && isOwnProfile())) {
            <div class="button-wrapper no-padding">
              @if (showActionsDropdown(contact)) {
                <div>
                  <app-progress-spinner [enabled]="saving" />
                </div>
              }
              @if (!showActionsDropdown(contact)) {
                <div>
                  <app-progress-spinner [enabled]="saving" />
                </div>
              }
              @if (showActionsDropdown(contact)) {
                <div class="no-padding-top-bottom align-left">
                  <p-select
                    #dd
                    [options]="actions"
                    [(ngModel)]="selectedAction"
                    [ngModelOptions]="{ standalone: true }"
                    (onChange)="actionEvent($event, dd)"
                    [(ngModel)]="selectedAction"
                    [ngModelOptions]="{ standalone: true }"
                    styleClass="action-drop-down"
                  />
                </div>
              }
              @if (showActionsDropdown(contact)) {
                <div id="save-btn" class="no-padding-top-bottom">
                  <button
                    pButton
                    label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                    icon="fa fa-fw fa-save"
                    (click)="saveContact()"
                    [disabled]="!this.form!.dirty || saving"
                  ></button>
                </div>
              }
              @if (!showActionsDropdown(contact)) {
                <div>
                  <button
                    pButton
                    label="{{ 'COMMON.LABEL.BUTTONS.SAVE' | translate }}"
                    icon="fa fa-fw fa-save"
                    (click)="saveContact()"
                    [disabled]="!this.form!.dirty || saving"
                  ></button>
                </div>
              }
            </div>
          }
        </div>
      </div>
      <hr id="contact-scroll-divider" />
      <p-scrollPanel styleClass="contact-scroll-panel">
        @if (!this._deviceService.isMobile()) {
          <p-tabs [value]="tabIndex">
            <p-tablist>
              <p-tab [value]="0">{{
                'CONTACT.LABEL.CONTACT_INFORMATION' | translate | uppercase
              }}</p-tab>
              <p-tab [value]="1" (onClick)="loadFacilities($event)">{{
                'CONTACT.LABEL.ASSOCIATED_FACILITIES' | translate | uppercase
              }}</p-tab>
            </p-tablist>
            <p-tabpanels>
              <p-tabpanel [value]="0">
                <app-contact-information-form
                  (goToContactEvent)="goToContact($event)"
                  [contact]="contact"
                  [form]="form"
                  [availableJobRoles]="availableJobRoles"
                  [availableCompanies]="availableCompanies"
                  [startTime]="startTime"
                  [endTime]="endTime"
                  [showWhenUnavailable]="showWhenUnavailable"
                  [selectedAvailability]="selectedAvailability"
                  [modifyButtonLabel]="modifyAvailabilityButtonLabel"
                  [modifyButtonIcon]="modifyAvailabilityIcon"
                  [filteredContacts]="filteredContacts"
                  [selectedAvailability]="selectedAvailability"
                  (updateAvailabilityEvent)="updateAvailability($event)"
                  (deleteAvailabilityEvent)="deleteAvailability($event)"
                  [availableContactMethods]="availableContactMethods"
                  (modifyAvailabilityEvent)="modifyAvailability($event)"
                  (clearAvailabilityEvent)="clearAvailability()"
                  (supervisorSearchEvent)="supervisorSearch($event)"
                  (whenUnavailableSearchEvent)="supervisorSearch($event)"
                  [writeAccess]="canEdit || (canEditOwn && isOwnProfile())"
                  [canViewPII]="canViewPII"
                  (formPristineEvent)="clearAsteriskFromTab()"
                  #cif
                />
              </p-tabpanel>
              <p-tabpanel [value]="1">
                @if (facilitiesLoaded) {
                  <app-contact-associate-facilities
                    [facilities]="facilities"
                    (openFacilityEvent)="openFacility($event)"
                    (openContactListEvent)="openContactList($event)"
                  />
                }
                <app-progress-spinner [enabled]="!facilitiesLoaded" />
              </p-tabpanel>
            </p-tabpanels>
          </p-tabs>
        }
        @if (this._deviceService.isMobile()) {
          <div>
            <app-contact-information-form
              (goToContactEvent)="goToContact($event)"
              [contact]="contact"
              [form]="form"
              [availableJobRoles]="availableJobRoles"
              [availableCompanies]="availableCompanies"
              [startTime]="startTime"
              [endTime]="endTime"
              [selectedAvailability]="selectedAvailability"
              [canViewPII]="canViewPII"
              [modifyButtonLabel]="modifyAvailabilityButtonLabel"
              [modifyButtonIcon]="modifyAvailabilityIcon"
              [filteredContacts]="filteredContacts"
              [selectedAvailability]="selectedAvailability"
              (updateAvailabilityEvent)="updateAvailability($event)"
              (deleteAvailabilityEvent)="deleteAvailability($event)"
              [availableContactMethods]="availableContactMethods"
              (modifyAvailabilityEvent)="modifyAvailability($event)"
              (clearAvailabilityEvent)="clearAvailability()"
              (supervisorSearchEvent)="supervisorSearch($event)"
              [writeAccess]="canEdit || (canEditOwn && isOwnProfile())"
            />
          </div>
        }
        @if (this._deviceService.isMobile()) {
          <div>
            <p-panel
              header="{{ 'CONTACT.LABEL.ASSOCIATED_FACILITIES' | translate }}"
              [toggleable]="true"
              toggler="header"
              (onAfterToggle)="toggleFacilities($event)"
              [collapsed]="startCollapsed"
            >
              @if (facilitiesLoaded) {
                <app-contact-associate-facilities
                  [facilities]="facilities"
                  (openFacilityEvent)="openFacility($event)"
                />
              }
              <app-progress-spinner [enabled]="!facilitiesLoaded" />
            </p-panel>
          </div>
        }
      </p-scrollPanel>
    </div>
  }
</blockable-div>
